import { ICreditorSearchResultModel } from "us.common/reducers/MainSearch/Interfaces";

export const CreditorSearchModel: ICreditorSearchResultModel = {
  data: [],
  isError: false,
  isLoading: false,
};
